import React, { useContext } from 'react'
import { DashboardContext } from '../../../context/DashboardContext'
import { formatDateHMMSS } from '../../../utils/formatDate'
import PropTypes from 'prop-types'

export function QuoteTooltip({ id, originalTranscriptSegment, whoSaidIt, participantId, startTime, content }) {
  const { openNoteDialog, getParticipant } = useContext(DashboardContext)

  return (
    <div className="w-[300px] text-left flex flex-col gap-[6px]">
      <p className="font-bold text-[16px] font-['Manrope']">{content}</p>
      <p className="font-normal text-[14px] font-['Manrope']">{originalTranscriptSegment}</p>
      <div className="flex items-center">
        <p className="font-semibold text-[14px] font-['Manrope']">
          {participantId ? getParticipant(participantId)?.name : whoSaidIt} @ {formatDateHMMSS(startTime)}・
        </p>
        <button
          className="text-linkBlue font-semibold text-[14px] font-['Manrope']"
          onClick={() => openNoteDialog('quote', id)}
        >
          See Quote ❯
        </button>
      </div>
    </div>
  )
}

QuoteTooltip.propTypes = {
  id: PropTypes.string,
  originalTranscriptSegment: PropTypes.string,
  whoSaidIt: PropTypes.string,
  participantId: PropTypes.string,
  startTime: PropTypes.number,
  content: PropTypes.string,
}
